// HelpHint — opinionated wrapper around InfoTooltip for the common
// "what does this thing do?" inline explainer. Body renders bold heading
// then plain copy below.
import type { ReactNode } from "react"
import { InfoTooltip } from "./info-tooltip"

type Props = {
  heading: string
  body: ReactNode
  side?: "top" | "right" | "bottom"
}

export function HelpHint({ heading, body, side = "top" }: Props) {
  return (
    <InfoTooltip side={side}>
      <span className="block font-semibold text-app-text">{heading}</span>
      <span className="mt-1 block text-app-muted">{body}</span>
    </InfoTooltip>
  )
}
